export const dndTypes = Object.freeze({
  //For massive distribution dnd system
  CARD: 'OT Card'
})